import styled from 'styled-components';
import { theme, toRem } from '../../styles';
import { colors } from '../../styles/colors';

export const StyledGuestDetails = styled.div`
  .toggle-message {
    display: flex;
    .toggle-width {
      width: 100% !important;
      &.half-width {
        width: 50%;
      }
    }
    @media ${theme.mediaQuery.allMobiles} {
      display: block !important;
      .toggle-width {
        width: 100% !important;
      }
    }
  }
  .red-border {
    width: 81%;

    @media ${theme.mediaQuery.allMobiles} {
      padding-left: 14px;
      width: 100%;
    }
    .info {
      border-color: ${colors.red};
      border-radius: 0px;
      padding: 14px 42px !important;
      @media ${theme.mediaQuery.allMobiles} {
        padding: 14px 42px 14px 20px !important;
      }
    }
  }
  .departure-margin {
    margin-left: 55px !important;
    @media ${theme.mediaQuery.allMobiles} {
      margin-left: 0px !important;
      margin-top: 8px !important;
    }
  }

  h1 {
    font: normal normal var(--t-title-m-font-weight) ${toRem(60)} / normal var(--t-title-font-family);
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(30)} / normal var(--t-title-font-family);
      margin-bottom: 12px;
    }
  }

  p,
  div {
    &.t-font-m {
      font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(24)} var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      }
      &.subTitle {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
        @media ${theme.mediaQuery.allMobiles} {
          font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
        }
      }
      &.bold {
        font-weight: 700 !important;
      }
    }
    &.t-font-s {
      font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(24)} var(--t-base-font-family);
      margin-bottom: 12px !important;
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
      }
      b {
        @media ${theme.mediaQuery.allMobiles} {
          display: block !important;
        }
      }
    }

    &.newLine {
      b {
        @media ${theme.mediaQuery.allMobiles} {
          display: block;
        }
      }
    }
  }

  .paddingZero {
    padding-left: 0px;
    padding-right: 15px;
    @media ${theme.mediaQuery.allMobiles} {
      padding-right: 0px;
    }
    &.SecondCol {
      p {
        margin-bottom: 12px !important;
        &.time-text {
          margin-bottom: 9px !important;
        }
        &.subTitleText {
          @media ${theme.mediaQuery.allMobiles} {
            padding-top: 0px;
          }
        }
      }
    }
  }

  .guest-details-page {
    position: relative;
  }

  .guest-details-page > .container {
    @media ${theme.mediaQuery.allMobiles} {
      padding: 0px;
    }
    @media ${theme.mediaQuery.largeDesktop} {
      max-width: 980px;
    }
  }
  .guest-detail-page-wrapper {
    max-width: 810px;
    padding: 48px 16px !important;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 28px 16px !important;
    }
    @media ${theme.mediaQuery.mediumTablet} {
      padding: 28px 16px !important;
    }
  }
  .m-input-field {
    width: 100%;
    max-width: 299px;
  }
  .m-input-field input:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    max-width: 299px;
    width: 100%;
    background-color: var(--t-button-primary-fg-color);
    color: var(--t-brand-fg-color);
    border: 1px solid var(--t-input-fields-bg-color);
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-overline-medium-font-sifamily);
    @media ${theme.mediaQuery.allMobiles} {
      max-width: none;
    }
  }

  h3 {
    font: normal normal 700 ${toRem(18)} / ${toRem(20)} var(--t-base-font-family, var(--t-font-family));
    margin-top: 10px;
    margin-bottom: 10px;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal 700 ${toRem(14)} / ${toRem(20)} var(--t-base-font-family, var(--t-font-family));
      margin-top: 0px !important;
    }
  }

  .hr {
    width: 100%;
    height: 0px;
    color: ${colors.grey5};
    margin: 25px 0;
    @media ${theme.mediaQuery.allMobiles} {
      margin: 22px 0;
    }
  }

  .hr-toggle {
    width: 100%;
    height: 0px;
    color: ${colors.grey5};
    margin: 8px 0;
    @media ${theme.mediaQuery.allMobiles} {
      margin: 15px 0;
    }
  }
  .hr-toggle-guest {
    width: 100%;
    height: 0px;
    color: ${colors.grey5};
    margin: 8px 0;
    margin-top: 17px;
  }
  .hr-toggle-addtion-guest {
    width: 100%;
    height: 0px;
    margin-bottom: 22.5px;
    color: ${colors.grey5};
  }

  input[type='checkbox']:checked + .toggle-slider {
    background-color: var(--t-interactive-accent-color);
    border-color: var(--t-interactive-accent-color);
  }

  .switch-toggle {
    font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
    color: var(--t-brand-fg-color);
    .toggle-text-no {
      margin-bottom: 9px;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 0px;
      }
    }
    .toggle-text {
      margin-bottom: 9px;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 0px;
      }
    }
    .toggle-switch-wrapper {
      margin-left: 8px;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 0px;
      }
    }
  }

  checkbox {
    margin-bottom: 20px;
  }
  .checkbox-label {
    margin-left: 30px;
    color: #000;
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family);
    margin-bottom: 15px;
  }

  .d-item-container {
    margin-right: 15px;
    @media ${theme.mediaQuery.smallMobile} {
      margin-right: 10px;
    }
  }
  .d-item {
    min-width: 125px;
  }
  .guest-details-page {
    padding: 0 0px;
    @media ${theme.mediaQuery.smallMobile} {
      padding: 0 0px;
    }
  }
  .flex-row-desktop {
    @media ${theme.mediaQuery.allMobiles} {
      flex-direction: column !important;
      align-items: normal !important;
      div {
        margin-right: 0px !important;
      }
    }
  }
  .mb-5 {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 12px !important;
    }
  }

  .page-wrapper {
    background-color: var(--t-brand-bg-color);
  }

  fieldset {
    max-height: 44px;
  }
  textarea {
    padding: 10px 15px !important;
    color: var(--t-brand-fg-color) !important;
    max-width: 299px;
    max-height: 44px;
    caret-color: var(--t-brand-fg-color);
    border: 1px solid var(--t-input-fields-bg-color) !important;
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
  }

  .align-items-end {
    @media ${theme.mediaQuery.allMobiles} {
      align-items: normal !important;
    }
  }

  input {
    border-radius: 0px !important;
  }

  input[type='checkbox'] + label {
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    margin-bottom: 15px;
    &:focus-visible {
      outline: none !important;
    }
  }

  .trip-contact-details {
    input[aria-checked='true'] + label {
      margin-bottom: 8px;
    }
  }

  .m-input-field {
    caret-color: var(--t-brand-fg-color);
  }

  .m-input-field label {
    display: none;
  }
  form {
    width: 100%;
  }
  .t-field-text-s {
    font: normal normal 700 0.875rem/1.25rem var(--t-base-font-family);
    position: relative;
    top: -1px;
  }
  .icon-clear {
    background: transparent;
  }
  .toast-message {
    position: fixed;
    z-index: 9999;
    max-width: 700px;
    top: 10%;

    .m-message-content {
      font-weight: 400;
      padding-top: 0.062rem !important;
    }
    .row {
      display: block;
      margin: 0px;
      @media ${theme.mediaQuery.allMobiles} {
        margin-right: -8px !important;
        margin-left: -8px !important;
      }
    }
    @media ${theme.mediaQuery.allMobiles} {
      right: 0px;
    }
    .m-message-modal {
      max-width: 100%;
      margin: 0 auto;
      border-radius: 0px;
      padding: 0px !important;
      .m-message-inline {
        border-radius: 0px;
        border: 1px solid #477d00 !important;
        background-color: #c1edaf !important;
        padding: 11.5px 1rem;
        &.error-sev1 {
          border: 1px solid #d13438 !important;
          background-color: #fdc8c4 !important;
        }
      }
    }
    &.error {
      .m-message-modal {
        border-radius: 0px !important;
      }
      .m-message-modal-contentwrap {
        padding: 0px !important;
      }
    }
  }
  .guest-form {
    position: relative;
    .d-flex {
      @media ${theme.mediaQuery.tablet} {
        align-items: flex-start !important;
      }
    }
  }

  .show-details {
    button {
      &.icon-clear {
        :before {
          color: var(--t-brand-fg-color) !important;
        }
      }
    }
  }
  .show-details div:first-child {
    margin-top: 29px;
  }
  .show-details div:last-child {
    margin-bottom: 29px;
  }
  .guest-form .show-details div:first-child {
    margin-top: 13px;
  }
  .children-form .show-details div:first-child,
  .pet-form .show-details div:first-child {
    margin-top: 5px;
  }
  .error-label div {
    font: normal normal var(--t-title-m-font-weight) 0.875rem/1rem var(--t-base-font-family);
    color: var(--t-form-error-color);
    padding-top: 2px;
  }
  .m-checkbox.is-error,
  .m-phoneNum.is-error {
    margin-bottom: 12px;
  }
  .additionalSelect {
    max-width: 299px;
    @media ${theme.mediaQuery.largeDesktop} {
      margin-bottom: 8px !important;
    }
  }

  .additionalDeskSel {
    max-width: 299px;
    padding-left: 0px;
    &:after {
      @media ${theme.mediaQuery.tabletScreen} {
        right: 10% !important;
      }
    }
  }
  .selectBox {
    width: 100%;
    background-color: var(--t-button-primary-fg-color);
    color: var(--t-brand-fg-color);
    font: normal normal var(--t-title-m-font-weight) var(--t-overline-medium-font-sifamily);
    padding: 0.85rem 1rem 0.85rem 0.85rem;
    border-radius: 0px;
    border: 1px solid var(--t-input-fields-bg-color);
    max-width: 107px;
  }
  .selectBox-xl {
    max-width: 299px;
    @media ${theme.mediaQuery.smallMobile} {
      max-width: 284px;
      width: 284px;
    }
  }
  select {
    &.is-error {
      border-color: var(--t-form-error-color) !important;
    }
  }
  .is-error {
    textarea {
      border-color: var(--t-form-error-color) !important;
    }
  }

  .textarea-section {
    max-width: 299px;
    max-height: 44px;
    padding: 0px;
    @media ${theme.mediaQuery.allMobiles} {
      max-height: 69px;
    }
  }

  .datetimeDiv,
  .time-picker {
    max-width: 299px;

    .m-dropdown-field {
      max-width: 108px;
      width: 100%;
      background-color: var(--t-button-primary-fg-color);
      color: var(--t-accent-color);
      font: normal normal var(--t-title-m-font-weight) var(--t-overline-medium-font-sifamily);
      border-radius: 0;
      border: 1px solid var(--t-input-fields-bg-color);
    }
  }

  .time-picker {
    &.align-items-end {
      align-items: flex-end !important;
    }
  }

  .date-picker-container {
    width: 100%;
    &.addVal {
      .date-picker {
        color: var(--t-brand-fg-color) !important;
      }
    }
    position: relative;
  }
  .date-picker {
    position: relative !important;
    display: inline-block;
    width: 100%;
    max-width: 180px;
    height: 32px;
    padding: 5px 8px 5px 15px;
    font: normal normal normal ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    border: 1px solid var(--t-input-fields-bg-color);
    border-radius: 0px;
    appearance: none;
    background-color: var(--t-button-primary-fg-color);
    color: ${colors.grey6} !important;
    &:focus {
      border: 1px solid var(--t-input-fields-bg-color);
    }
  }

  /* Dropdown icon styling */
  .date-picker::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: 44%;
    right: 5%;
    border-left: 1px solid var(--t-brand-fg-color);
    border-bottom: 1px solid var(--t-brand-fg-color);
    transform: rotate(-45deg) translateY(-50%);
    pointer-events: none;
  }
  .singledatepicker {
    position: absolute; /* Position the calendar absolutely within the container */
    left: 0; /* Align it with the left side of the input field */
    z-index: 1; /* Ensure the calendar is above the input field */
    bottom: 100%;
  }

  input[type='text'] {
    background-color: var(--t-button-primary-fg-color);
    font: normal normal normal var(--t-overline-medium-font-sifamily);
    border-radius: 0px;
    border: 1px solid var(--t-input-fields-bg-color);
    &:focus {
      border-bottom: var(--t-brand-fg-color) solid 1px;
    }
  }

  .survey-wrapper__children {
    &.color-scheme3 {
      input::placeholder {
        color: ${colors.grey3} !important;
      }
    }
  }
  .header-note {
    p {
      margin-bottom: 5px;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 0px;
      }
      &:nth-child(1) {
        margin-bottom: 12px;
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 0px;
        }
      }
    }
  }

  .time-text {
    font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(12)} var(--t-base-font-family) !important;
    margin-bottom: 0px !important;
    white-space: nowrap !important;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 12px !important;
    }
  }

  .toast-message .close-button {
    background: none;
    border: none;
    font-size: 0.9rem;
    color: #1c1c1c;
    position: absolute;
    right: 12px;
    cursor: pointer;
  }

  .m-message-modal-contentwrap {
    position: relative;
    background-color: transparent !important;
    padding: 0px !important;
  }

  input[type='checkbox']:checked + label:before {
    outline: none !important;
  }

  .spcial-occasion-checkboxes {
    margin-top: 0 !important;
  }

  .twoTitle {
    p {
      margin-bottom: 16px !important;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 12px !important;
      }
    }
  }

  .btn-center {
    @media ${theme.mediaQuery.allMobiles} {
      align-items: center !important;
    }
  }
  button {
    font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family);
    &.continue-btn {
      font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
      width: 145px;
      padding: 10px 24px !important;
      @media ${theme.mediaQuery.allMobiles} {
        width: 274px;
        height: auto;
        padding: 8px 24px 7px !important;
        font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family) !important;
      }
    }
  }
  button.continue-btn:disabled {
    cursor: not-allowed; /* Indicate the button is not clickable */
    opacity: 0.5; /* Optional: make the button appear faded */
    background-color: var(--t-button-secondary-fg-color);
    border-color: var(--t-button-primary-border-color);
  }

  .custom-select-wrapper {
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding-right: 30px;
      position: relative;
      ackground-color: var(--t-button-primary-fg-color);
      font-family: inherit;
      height: 32px;
      padding: 5px 10px 5px 15px;
      font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    }

    &.p-0::after {
      top: 40%;
      right: 6%;
      @media ${theme.mediaQuery.allMobiles} {
        top: 43%;
        right: 5%;
      }
      @media ${theme.mediaQuery.tabletScreen} {
        right: 5%;
      }
    }
  }

  .custom-select-wrapper {
    position: relative;
  }

  .custom-select-wrapper::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: 12px !important;
    right: 7%;
    border-left: 2px solid var(--t-brand-fg-color);
    border-bottom: 2px solid var(--t-brand-fg-color);
    transform: rotate(-45deg) translateY(-50%);
    pointer-events: none;
    transition: transform 0.3s;
  }

  .arrival-departure {
    max-width: 299px;
    margin-bottom: 24px !important;
    &:nth-child(3) {
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 0px !important;
      }
    }

    select {
      height: 32px;
      padding: 0px 10px 0px 15px;
    }
    &.custom-select-wrapper::after {
      top: 45% !important;
      right: 4%;
      @media ${theme.mediaQuery.allMobiles} {
        right: 4% !important;
      }
      @media ${theme.mediaQuery.smallMobile} {
        right: 5% !important;
      }
    }
  }

  .spcial-occasion-checkboxes {
    .col-md-6 {
      @media ${theme.mediaQuery.allMobiles} {
        width: 50%;
      }
    }
  }

  input[type='text'] {
    height: 32px;
    padding: 0px 10px 0px 15px !important;
    font: normal normal normal ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
  }

  .trip-contact-details {
    div {
      input[type='checkbox'] + label {
        margin-bottom: 8px !important;
      }
      .m-phoneNum {
        margin-bottom: 8.5px !important;
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 0px !important;
        }
      }
      .m-form-group {
        margin-bottom: 8px !important;
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 0px !important;
        }
      }
    }
  }
  .trip-contact-check {
    @media ${theme.mediaQuery.allMobiles} {
      margin-top: 16px !important;
    }
  }

  .horizontal-line {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 12px !important;
    }
  }

  .occasionToggle {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 12px !important;
    }
  }

  .guestSubtitle {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 12px !important;
    }
  }
  .guestButton-wrapper {
    @media ${theme.mediaQuery.allMobiles} {
      margin-top: 12px !important;
    }
  }

  select:invalid {
    color: ${colors.grey6} !important;
  }

  .guestButton {
    width: 130px;
    height: auto;
    padding: 7px 10px 6px !important;
    font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
  }

  .addGuestButton {
    @media ${theme.mediaQuery.allMobiles} {
      margin-top: 12px !important;
    }
  }
  .input-icon {
    position: absolute;
    width: 8px;
    height: 8px;
    top: 8px;
    right: 13%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .input-icon i {
    color: var(--t-brand-fg-color);
    font-style: normal;
  }
  .DayPicker-wrapper-react-el {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  }
  .row {
    &.accesref {
      width: 100%;
      max-width: 700%;
    }
  }
  [class^='m-message'].success .m-message-content-wrap::before {
    font-size: 20px;
  }
  .red-asterisk {
    color: var(--t-form-error-color);
  }
  p.error-message {
    font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / 1rem var(--t-base-font-family) !important;
    color: var(--t-form-error-color);
    padding-top: 2px;
    line-height: 10px !important;
  }
  .error-container {
    display: flex;
    text-align: left !important;
    align-items: flex-start !important;
    margin-bottom: 8px;
    @media ${theme.mediaQuery.allMobiles} {
      margin-top: 8px !important;
    }
  }
  .error-icon {
    margin-right: 2px;
    display: inline-flex;

    i {
      margin-top: 2px !important;
      font-style: normal;
      color: var(--t-form-error-color);
      font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / 1rem var(--t-base-font-family) !important;
      line-height: 10px !important;
    }
  }
  .is-error,
  .has-error {
    p,
    &.time-text {
      margin-bottom: 2px !important;
    }
  }

  .pet-form {
    .d-flex {
      > .col-md-6 {
        @media ${theme.mediaQuery.tabletDesktop} {
          margin-right: 13px !important;
        }
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 16px !important;
        }
      }
      p,
      li {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
        color: var(--t-brand-fg-color);
        @media ${theme.mediaQuery.allMobiles} {
          font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
        }
      }
    }
  }

  .top-right-content {
    justify-content: end;
    width: 100%;
    @media ${theme.mediaQuery.allMobiles} {
      flex-direction: column;
      align-items: end;
      margin-bottom: 10px;
    }
  }
  .top-right-content p {
    margin-bottom: 27px !important;
    &:first-child {
      margin-right: 15px !important;
      @media ${theme.mediaQuery.allMobiles} {
        margin-right: 0 !important;
      }
    }
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family) !important;
      margin-bottom: 0px !important;
    }
  }
  .summary-section {
    p {
      span {
        b {
          display: inline !important;
        }
      }
    }
  }
  .toggle-section {
    width: 93%;
    display: flex;
    justify-content: space-between;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 1rem;
    }
  }
  .trip-contact-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 8px;
    @media ${theme.mediaQuery.allMobiles} {
      display: flex;
      flex-direction: column;
    }
  }
  .arrivaldata {
    gap: 11px;
  }
  .toggle-trip {
    margin-bottom: 8px;
    margin-top: 17px;
  }
  .toggle-arrival-hr {
    margin-bottom: 5px;
  }
  .toggle-addchild-hr {
    margin-bottom: 8px;
  }
  .hr-visible {
    width: 100%;
    height: 0px;
    margin-bottom: 22.5px;
    color: ${colors.grey5};
    opacity: 1;
    transition: opacity 0.4s ease, max-height 0.4s ease;
  }
  .hr-hidden {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 0.4s ease, max-height 0.4s ease;
  }
  .childButton {
    white-space: nowrap;
    margin-left: 15px !important;
    min-width: 130px;
  }
  .dynamicSection {
    width: 100%;
  }
`;
